import script from "./WeekRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./WeekRow.vue?vue&type=script&setup=true&lang=ts"

import "./WeekRow.vue?vue&type=style&index=0&id=70ffe028&lang=css"

const __exports__ = script;

export default __exports__